export const PO_TOTAL_MIN = 0;
export const PO_TOTAL_MAX = 99999999.99;
export const PO_TOTAL_OVERRIDE_MIN = 0;
export const PO_TOTAL_OVERRRIDE_MAX = 99999999.99;
export const PO_TOTAL_BILLABLE_MIN = 0.01;
export const PO_TOTAL_OVERRIDE_BILLABLE_MIN = 0.01;
export const PO_TOTAL_THRESHOLD = 350.01;
export const SPECIAL_JOB_MIN_PO_TOTAL = 250.01;
export const PIECEWORK_MAX_PO_TOTAL = 250.0;
